import React, { useState, useEffect } from "react";
import AsideLeft from "./AppAdminComponents/AsideLeft";
import NavBarNotificationBar from "./AppAdminComponents/NavBarNotificationBar";
import { getuser } from "../helpers/user.helper";
import formatMoney from "../helpers/money.helper";
import formatDate from "../helpers/date.helper";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { ListProducts, GetCplusIdProduct, GetProductLikeName } from "../services/products.service";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import "primeicons/primeicons.css";
import Footer from "../components/Footer";

export default function Products() {
  let navigate = useNavigate();
  const [productsArray, setProduct] = useState(undefined);
  const [totalPage, setTotalPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [filters, setFilters] = useState();

  useEffect(() => {
    let user = getuser();
    //Redireciona caso não esteja logado
    if (!user) {
      navigate("/login");
    }

    async function fetchData() {
      await fetchProducts();
    }

    fetchData();
  }, []);

  async function fetchProducts() {
    let products = await ListProducts(10, 1, true);
    setProduct(products?.data.data);
    setTotalPage(products.data.totalPages);
    setTotalRecords(products.data.totalItems);
  }

  const showItemClick = (rowData) => {
    navigate(`/produto/${rowData.id}`);
  };

  let renderLoad = () => {
    return (
      <div className="table-footer text-center">
        <Loader
          type="ThreeDots"
          color="#343A40"
          height={100}
          width={100}
          visible={true}
        />
      </div>
    );
  };

  const optionButtons = (rowData, column) => {
    return (
      <div>
        <button
          onClick={() => showItemClick(rowData)}
          title="Visualizar item"
          type="button"
          className="btn btn-icon btn-info btn-sm"
        >
          <i className="fa fa-edit"></i>
        </button>
      </div>
    );
  };

  const onPage = async (event) => {
    setFirst(event.first);
    let products = await ListProducts(event.rows, event.page + 1, true);
    setProduct(products?.data.data);
  };

  const onFilter = async (event) => {
    if(Object.keys(event.filters).length === 0){
        fetchProducts();
    }
    else{
        const { codProduto, descricao } = event.filters;
        if (codProduto && codProduto.value.length === 6  ){
            const productresult = await GetCplusIdProduct(codProduto.value);
            setProduct(productresult.data);
            setTotalRecords(productresult.data.length);
        };

        if (!codProduto && descricao.value.length >  3  ){
            const productresult = await GetProductLikeName(descricao.value);
            setProduct(productresult.data);
            setTotalRecords(productresult.data.length);
        };
    }
    setFilters(event.filters);
  };

  return (
    <>
      <div className="wrapper">
        {/* Navbar */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <NavBarNotificationBar />
        </nav>
        <AsideLeft option="produtos" />
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0 text-dark">Produtos</h1>
                </div>
              </div>
            </div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                {/* Left col */}
                <section className="col-lg-12 connectedSortable">
                  {/* Custom tabs (Charts with tabs)*/}
                  <div className="card">
                    <div className="card-header">
                      {/* <div className="card-tools">
                                                <ul className="nav nav-pills ml-auto">
                                                    <li className="nav-item">
                                                        <a className="nav-link active" href="/venda/nova" data-toggle="tab">Nova</a>
                                                    </li>
                                                </ul>
                                            </div> */}
                    </div>
                    <div className="card-body">
                      {!productsArray ? (
                        renderLoad()
                      ) : (
                        <div className="tab-content p-0">
                          <DataTable
                            value={productsArray}
                            rowHover
                            paginator
                            rows={10}
                            lazy={true}
                            first={first}
                            onPage={(event) => onPage(event)}
                            onFilter={onFilter}
                            filters={filters}
                            totalRecords={totalRecords}
                            rowsPerPageOptions={[20, 40, 50]}
                            style={{ marginBottom: 50 }}
                            responsive
                            className="p-datatable-customers"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                            emptyMessage="Nenhum dado a ser listado"
                          >
                            <Column
                              field="codProduto"
                              header="Código"
                              filter={true}
                            />
                            <Column
                              field="descricao"
                              header="Descrição"
                              filter={true}
                            />
                            <Column
                              field={(row) => formatMoney(row.preco)}
                              header="Preço"
                            />
                            <Column
                              field={(row) => formatDate(row.dataImportacao)}
                              header="Atualizado Em"
                            />
                            <Column
                              key="123"
                              body={optionButtons}
                              bodyStyle={{
                                textAlign: "center",
                                overflow: "hidden",
                              }}
                            />
                          </DataTable>
                        </div>
                      )}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
}
